import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from 'angular-auth-oidc-client';
import { buildOidcConfigs } from './core/auth';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomHttpInterceptor, LoaderInterceptor } from './core/interceptors';
import { CommonService } from './core/services';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeModule } from './modules/home/home.module';
import { NgxsModule } from '@ngxs/store';
import { AngularMaterialModule } from './core/sharedmodules';
import { GlobalErrorHandler } from './core/interceptors/global-error-handler ';

@NgModule({
  declarations: [AppComponent],
  imports: [
    // One OIDC configuration per sign-in system enabled for this environment (core/auth).
    AuthModule.forRoot({ config: buildOidcConfigs(window.location.origin) }),
    BrowserModule,
    AppRoutingModule,
    HomeModule,
    AngularMaterialModule,
    BrowserAnimationsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-spin-fade' }),
    NgxsModule.forRoot([]),
  ],
  providers: [
    CommonService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
